import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'

import { eventTypeOptions } from '../../options'
import styles from '../../styles'
import { InputBase, makeStyles, Select } from '@material-ui/core'
import { LOCATION_STATUS_ENUM } from '../../../../../../../../shared/constants'
import { SubmitButton } from '../../../../../../../../Components/Form'
import TextInput from '../../../../../../../../Components/_newInputs/TextInput'
import { PlaceAutocomplete } from '../../../../../../../../Components/_newInputs/PlaceAutocomplete'
import { Map } from 'Components/Map'
import pinIcon from 'Assets/Images/icons/mission-pin-vector.svg'
import Checkplates from '../../parts/Checkplates'
import Sheltered from '../../parts/icons/sheltered'
import Unsheltered from '../../parts/icons/unsheltered'
import Event from '../../parts/icons/event'
import SquareCheckBox from '../../../../../../../../Assets/Images/icons/squareCheckBox'
import TextArea from '../../../../../../../../Components/_newInputs/TextArea'

const useStyles = makeStyles(styles)

const BaseInformation = ({
  baseLocationForm,
  handleLocatonArchive,
  handleLocatonUnarchive,
  handleBaseLocationFormChange,
  locationTypeOptions,
  handlePlaceChanged,
  isGoogleLoaded,
  city,
  mapCenter,
  defaultCenter,
  handleMapMarkerDrag,
  visible,
  isEdit,
}) => {
  const muiClasses = useStyles()

  const shelteredCheckplatesOptions = [
    {
      label: 'Sheltered',
      active: baseLocationForm.isSheltered,
      onChange: () => handleBaseLocationFormChange('isSheltered', true),
      icon: (color = '#707087') => {
        return <Sheltered color={color} />
      },
    },
    {
      label: 'Unsheltered',
      active: !baseLocationForm.isSheltered,
      onChange: () => handleBaseLocationFormChange('isSheltered', false),
      icon: (color = '#707087') => {
        return <Unsheltered color={color} />
      },
    },
  ]

  const eventCheckplatesOptions = [
    {
      label: 'Event',
      active: baseLocationForm.isEvent,
      onChange: () =>
        handleBaseLocationFormChange('isEvent', !baseLocationForm.isEvent),
      icon: (color = '#707087') => {
        return <Event color={color} />
      },
    },
  ]

  if (!visible) return null

  return (
    <div style={styles.contentArea}>
      <div style={styles.headerContainer}>
        <div style={styles.contentTitle}>Basic Information</div>

        {isEdit && baseLocationForm.status !== LOCATION_STATUS_ENUM.ARCHIVED && (
          <div>
            <SubmitButton
              variant="outlined"
              size="small"
              value={'Archive'}
              onClick={handleLocatonArchive}
              style={styles.button}
            />
          </div>
        )}

        {isEdit && baseLocationForm.status === LOCATION_STATUS_ENUM.ARCHIVED && (
          <div>
            <SubmitButton
              variant="outlined"
              size="small"
              value={'Unarchive'}
              onClick={handleLocatonUnarchive}
              style={styles.button}
            />
          </div>
        )}
      </div>

      <div style={styles.baseInformationHeaderContainer}>
        <div style={styles.inputContainer}>
          <TextInput
            label="Name *"
            placeholder="Enter location name"
            value={baseLocationForm.name}
            onChange={e => handleBaseLocationFormChange('name', e.target.value)}
          />
        </div>
        <div style={styles.inputContainer}>
          <TextInput
            label="Label *"
            placeholder="Enter location label"
            value={baseLocationForm.label}
            onChange={e =>
              handleBaseLocationFormChange('label', e.target.value)
            }
          />
        </div>
      </div>
      <div style={styles.dropdownContainer}>
        <div style={styles.inputTitle}>Type *</div>
        <Select
          className={muiClasses.select}
          value={baseLocationForm.typeId}
          onChange={e => handleBaseLocationFormChange('typeId', e.target.value)}
          label="Type *"
          input={<InputBase style={styles.inputRoot} disableUnderline />}
        >
          {locationTypeOptions &&
            locationTypeOptions.map(option => (
              <MenuItem
                key={option.id || option.value}
                value={option.id || option.value}
              >
                {option.name || option.label}
              </MenuItem>
            ))}
        </Select>
      </div>

      <div style={styles.inputTitle}>Address *</div>
      <div style={{ height: '54px' }}>
        {city.name && isGoogleLoaded ? (
          <PlaceAutocomplete
            countryCode={city.country.code}
            placeholder={'Enter a city, neighborhood, or specific address'}
            onPlaceChanged={handlePlaceChanged}
            defaultValue={baseLocationForm.address}
            city={{ name: city.name }}
            inputValue={baseLocationForm.address}
            setInputValue={value =>
              handleBaseLocationFormChange('address', value)
            }
            disabled={isEdit}
          />
        ) : (
          <div
            style={{
              height: 52,
            }}
          >
            Loading...
          </div>
        )}
      </div>
      <Map
        defaultZoom={12}
        mapPositionLat={mapCenter.lat}
        mapPositionLng={mapCenter.lng}
        useDefaultCenter={false}
        markers={[
          {
            markerPositionLat: baseLocationForm.location
              ? baseLocationForm.location.lat
              : defaultCenter.lat,
            markerPositionLng: baseLocationForm.location
              ? baseLocationForm.location.lng
              : defaultCenter.lng,
            onMarkerDragEnd: e => {
              const lat = e.latLng.lat()
              const lng = e.latLng.lng()
              handleMapMarkerDrag(lat, lng)
            },
            isMarkerDraggable: isEdit ? false : true,
            useDefaultIcon: true,
            icon: {
              url: pinIcon,
              scaledSize: { width: 40, height: 40 },
            },
          },
        ]}
      />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={styles.inputTitle}>Environment</div>
        <div style={styles.checkplatesContainer}>
          <Checkplates options={shelteredCheckplatesOptions} />
          <Checkplates options={eventCheckplatesOptions} />
          <div
            style={styles.checkboxContainer}
            onClick={() =>
              handleBaseLocationFormChange(
                'needsPermit',
                !baseLocationForm.needsPermit,
              )
            }
          >
            <SquareCheckBox active={baseLocationForm.needsPermit} />
            <span style={styles.needsPermitLabel}>Needs Permit</span>
          </div>
        </div>
      </div>
      {baseLocationForm.isEvent && (
        <div style={styles.dropdownContainer}>
          <div style={styles.inputTitle}>Event Type *</div>
          <Select
            className={muiClasses.select}
            value={baseLocationForm.eventType}
            onChange={e =>
              handleBaseLocationFormChange('eventType', e.target.value)
            }
            label="EventType"
            input={<InputBase style={styles.inputRoot} disableUnderline />}
          >
            {eventTypeOptions.map(option => (
              <MenuItem
                key={option.id || option.value}
                value={option.id || option.value}
              >
                {option.name || option.label}
              </MenuItem>
            ))}
          </Select>
          <TextArea
            label="Event Description *"
            placeholder="Enter description to guide AI Roster."
            value={baseLocationForm.description}
            onChange={e =>
              handleBaseLocationFormChange('description', e.target.value)
            }
            limit={200}
          />
        </div>
      )}
    </div>
  )
}

export default BaseInformation
